import {RouteDefinition} from '../../../routes';
import {BackgroundSettingsScreen} from './BackgroundSettingsScreen';

export const CustomizationSettingsRoutes:RouteDefinition[]=[
    {
        routerLink: '/settings/customization',
        component: BackgroundSettingsScreen,
    },
];
